import React from 'react';

const AdminNotifications = () => (
  <div className="admin-notifications">
    <h3>Notifications & Communication</h3>
    <p>Send push notifications and announcements — UI to be implemented.</p>
  </div>
);

export default AdminNotifications;
